exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lar_form_group .form_label[data-v-6ed7cbcd] {\n  color: #787878;\n  display: block;\n  min-height: 1.6rem;\n  margin-bottom: 0.5rem;\n}", ""]);

// exports
